
import { Component, Vue } from "vue-property-decorator";
import UserList from "@/components/user/UserList.vue";
import User from "@/domain/user/User";
import RemoteServices from "@/services/RemoteServices";
import UserDialog from "@/components/user/UserDialog.vue";
@Component({
  components: { UserDialog, UserList }
})
export default class UsersView extends Vue {
  userList: User[] = [];

  showCreateUserDialog = false;

  showUserDialog = false;

  selectedUser: User = new User();

  loading = false;

  mounted() {
    this.refreshUsers();
  }

  async refreshUsers() {
    this.loading = true;
    this.userList = await RemoteServices.getUsers();
    this.loading = false;
  }

  addUser(newUser: User) {
    this.userList.push(newUser);
  }

  newUser() {
    this.showCreateUserDialog = true;
  }

  editUser(user: User) {
    this.selectedUser = user;
    this.showUserDialog = true;
  }

  deleteUser(user: User) {
    this.userList = this.userList.filter(u => u.userId !== user.userId);
  }
}
